import { HaloAcronym } from "@climaterisk/facades_ts/halo_request";
import { ArchetypeConfig } from "../../schema";

interface HaloArchetypeConfig extends ArchetypeConfig {
  value: HaloAcronym;
}

/**
 * Archetypes specifically used for HKMA Hub and its Halo architecture.
 */
export const defaultHaloArchetypes: HaloArchetypeConfig[] = [
  {
    id: "HRRF",
    name: "High Rise Residential Flat",
    value: "HighRiseResidentialFlatHK",
    category: "residential",
    description: "",
    defaultBuildYear: 1986,
    defaultHeightAboveGround: 0.37,
  },
  {
    id: "LRRF",
    name: "Low Rise Residential Flat",
    value: "LowRiseResidentialFlatHK",
    category: "residential",
    description: "",
    defaultBuildYear: 1989,
    defaultHeightAboveGround: 0.37,
  },
  {
    id: "THF",
    name: "Freestanding House HK",
    value: "FreestandingHouseHK",
    category: "residential",
    description: "",
    defaultBuildYear: 1988,
    defaultHeightAboveGround: 0.5,
  },
  {
    id: "HRSC",
    name: "High Rise Structure Commercial",
    value: "HighRiseStructureCommercialHK",
    category: "commercial",
    description: "",
    defaultBuildYear: 1993,
    defaultHeightAboveGround: 0.37,
  },
  {
    id: "LRSC",
    name: "Low Rise Structure Commercial",
    value: "LowRiseStructureCommercialHK",
    category: "commercial",
    description: "",
    defaultBuildYear: 1985,
    defaultHeightAboveGround: 0.37,
  },
  {
    id: "SSM",
    name: "Supermarket Shopping Mall",
    value: "SupermarketShoppingMallHK",
    category: "commercial",
    description: "",
    defaultBuildYear: 1994,
    defaultHeightAboveGround: 0.19,
  },
];
